var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVariableInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.692,
    height: 14.692,
    viewBox: "0 0 14.692 14.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-information-circle-outline",
    "data-name": "Icon ionic-ios-information-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88957",
    "data-name": "Path 88957",
    d: "M16.552,11.411a.728.728,0,1,1,.724.706A.707.707,0,0,1,16.552,11.411Zm.049,1.261H17.95v5.089H16.6Z",
    transform: "translate(-6.558 -3.65)",
    fill: "#202124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88958",
    "data-name": "Path 88958",
    d: "M10.721,4.364a6.355,6.355,0,1,1-4.5,1.861,6.315,6.315,0,0,1,4.5-1.861m0-.989a7.346,7.346,0,1,0,7.346,7.346,7.345,7.345,0,0,0-7.346-7.346Z",
    transform: "translate(0 0)",
    fill: "#202124"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVariableInfo);
export default __webpack_public_path__ + "static/media/icon-variable-info.b147e408.svg";
export { ForwardRef as ReactComponent };